// extracted by mini-css-extract-plugin
export default {"tag":"TagChip_tag__xHy9C","container":"TagChip_container__m3Ofk","tag-count":"TagChip_tag-count__HTCyJ"};